import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { IntegrationGitService } from './integration-git.service';

@Injectable({ providedIn: 'root' })
export class IntegrationGitFactoryService extends AbstractGitFactoryService<IntegrationGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: IntegrationGitService,
    });
  }
}
